import React, { Component } from 'react';
import { View, TouchableOpacity, Text, Animated } from 'react-native';
// import { observer } from 'mobx-react';
import styles from './style';
import { DeviceInfo } from 'qunar-react-native'
import { getQueryParam } from '@qnpm/cmn-component-order';
// import rootStore from '../OrderMainView/Store/index';
// import generateRNUrl from '../../../utils/generateRNUrl';
// import {navigate} from '../../../utils/navigate'

const { isMini, isWeb } = DeviceInfo;

interface HeaderInterface {
    filterTitle?: string;
    enableFilter?: boolean;
    filterTitleOnPress?: () => void;
    rightBtnOnPress?: () => void;
    downArrowAnimation: () => void;
    upArrowAnimation: () => void;
}
// @observer
class Header extends Component<any> implements HeaderInterface {
    public state = {
        arrowDown: new Animated.Value(0),
        isQunar: false
    };

    public componentDidMount() {
        // const uiStateStore = rootStore.uiState;
        // reaction(
        //     () => uiStateStore.isShowFilterBar,
        //     (isShowFilterBar) => {
        //         const { arrowDown } = this.state;
        //         Animated.timing(arrowDown, {
        //             toValue: isShowFilterBar ? 1 : 0,
        //             duration: 200
        //         }).start();
        //     }
        // );
        this.checkTouch();
    }

    // 如果是web订单校验是否是端内打开
    public checkTouch = () => {
        if (isWeb) {
            const hytiveReg = "(^|\\s)(qunar[^\\/]+)\\/([\\d\\.]+)";
            const isQunar = !!(navigator.userAgent.toLowerCase().match(hytiveReg));
            this.setState({
                isQunar
            })
        }
    }

    public downArrowAnimation() {
        const { arrowDown } = this.state;
        Animated.timing(arrowDown, {
            toValue: 0,
            duration: 200,
            useNativeDriver: true
        }).start();
    }

    public upArrowAnimation() {
        const { arrowDown } = this.state;
        Animated.timing(arrowDown, {
            toValue: 1,
            duration: 200,
            useNativeDriver: true
        }).start();
    }

    public closeWebview = () => {
        window.WebViewJavascriptBridge.invoke('webview.back');
    }

    back = () => {
        const { isQunar } = this.state;
        if (isWeb && isQunar) {
            this.closeWebview();
        } else {
            if (isWeb && location.href.search('back2Home=true') !== -1) {
                location.href = 'https://touch.qunar.com';
            } else {
                Ext.back();
            }
        }
    }

    public render() {
        const { arrowDown, isQunar } = this.state;
        const rotateZ = arrowDown.interpolate({
            inputRange: [0, 1],
            outputRange: ['0deg', '180deg']
        });
        const { hideBack, hideRight } = this.props || {};

        return (
            <View>
                <View style={isWeb && isQunar ? styles.statusBar2 : styles.statusBar} />
                <View style={styles.header}>
                    {!hideBack && <TouchableOpacity
                        activeOpacity={1}
                        style={styles.backBtnWrapper}
                        onPress={this.back}
                    >
                        <Text style={styles.backBtn}>&#xf07d;</Text>
                    </TouchableOpacity>}
                    {!!hideBack && <View style={styles.backBtnWrapper}></View>}
                    <View style={styles.titleWrapper}>
                        <TouchableOpacity
                            activeOpacity={1}
                            onPress={() => {
                                this.props.filterTitleOnPress && this.props.filterTitleOnPress();
                            }}
                            style={styles.title}
                        >
                            {/* <Text style={styles.titleText}>{rootStore.uiState.filterBarTitle}</Text> */}
                            <Text style={styles.titleText}>{this.props.filterTitle}</Text>
                            {/* <Text style={styles.titleText}>{this.props.title}</Text> */}
                            {/* {rootStore.uiState.enableFilter ? (
                            <Animated.Text style={[styles.arrow, { transform: [{ rotateZ }] }]}>
                                &#xf032;
                            </Animated.Text>
                        ) : null} */}
                            {this.props.enableFilter && !isMini ? (
                                <Animated.Text style={[styles.arrow, { transform: [{ rotate: rotateZ }] }]}>
                                    &#xf032;
                                </Animated.Text>
                            ) : null}
                            {this.props.enableFilter && isMini ? (
                                <Text style={[styles.arrow]}>
                                    &#xf032;
                                </Text>
                            ) : null}
                        </TouchableOpacity>
                    </View>
                    {
                        isMini || hideRight || (isWeb && getQueryParam('hasMobile') === "0") ?
                            <View style={styles.orderSearchBtnWrapper} />
                            :
                            <TouchableOpacity
                                activeOpacity={1}
                                style={styles.orderSearchBtnWrapper}
                                onPress={() => {
                                    this.props.rightBtnOnPress && this.props.rightBtnOnPress();
                                }}
                            >
                                <Text style={styles.orderSearchBtn}>手机查单</Text>
                            </TouchableOpacity>
                    }
                </View>
            </View>
        );
    }
}

export default Header;
